exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h1 {\n  font-weight: 900;\n    font-size: 2rem;\n    line-height: 1;\n}\n\n.text.small {\n  font-size: 0.5rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.footer {\n  text-align: right;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Footer/Footer.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Footer/Footer.css
// module chunks = 0